const d3 = require('d3');
import * as d3annotation from 'd3-svg-annotation';
import {gVars} from './00-global-init.js';
import {cd27HispanicPercent} from './00-global-functions.js';

export function setCentroids(
    c_year, centroid_27, centroid_nueces, svg_elements, first_year, all_texas, centroid_35
  ) {
  var centroids = [],
    wrapper_id = svg_elements[3],
    label_val,
    x_val,
    y_val,
    dy_val,
    dx_val,
    wrap,
    map_class = svg_elements[4];

  // Set centroids based on year and map
  // If we're working with a overlay map, we'll run this first centroids
  // So we can have annotations center in the middle of district 27
  if (c_year == 1982 && wrapper_id == gVars.map_mini || gVars.overlay_maps.includes(wrapper_id)) {
    // If we're dealing with an overlay map
    if ( gVars.overlay_maps.includes(wrapper_id) ) {
        wrap = 160,
        dy_val = 5,
        dx_val = 12;

      if (c_year == 2010) {
        label_val = cd27HispanicPercent(c_year) + ' percent of the voting age population in CD-27 was Hispanic in 2010.';
      } else if (c_year == 2012) {
        label_val = cd27HispanicPercent(c_year) + ' percent of the voting age population was Hispanic after the district lines were redrawn.';
      }

      if (window.innerWidth < gVars.mobile_width) {
        if (c_year == 2010) {
          x_val = centroid_27[0][0] + 15;
          y_val = centroid_27[0][1] - 30;
        } else {
          x_val = centroid_27[0][0];
          y_val = centroid_27[0][1] + 15;
        }
        wrap = 85;
      } else if (c_year == 2010) {
        x_val = centroid_27[0][0] + 20;
        y_val = centroid_27[0][1] - 25;
      } else {
        x_val = centroid_27[0][0] + 10;
        y_val = centroid_27[0][1] + 30;
      }
    } else {
      wrap = 60;
      label_val = 'Congressional District 27';
      x_val = centroid_27[0][0] + 7;
      y_val = centroid_27[0][1] - 5;
      dy_val = 10;
      dx_val = 20;
    }

    centroids.push({
      class: 'district-27',
      data: centroid_27,
      label: label_val,
      x: x_val,
      y: y_val,
      dy: dy_val,
      dx: dx_val,
      wrap: wrap
    });
  } else if (c_year == 1984 && wrapper_id == gVars.map_mini) {
    centroids.push({
      class: 'map-mini',
      data: centroid_nueces,
      label: 'Nueces County, which is inside CD-27',
      x: centroid_nueces[0][0] + 13,
      y: centroid_nueces[0][1],
      dy: 10,
      dx: 15
    });
  } else if (c_year === 2010 && wrapper_id == gVars.map_farenthold_home) {
    if (window.innerWidth > gVars.mobile_width) {
      x_val = centroid_nueces[0][0] + 24,
      y_val = centroid_nueces[0][1] + 1,
      dy_val = 20,
      dx_val = 15,
      wrap = 120;
      label_val = "After 2010, map drawers looked to redraw CD-27 and keep Farenthold's home county of Nueces.";
    } else {
      x_val = centroid_nueces[0][0] + 20,
      y_val = centroid_nueces[0][1] - 10,
      dy_val = 0,
      dx_val = 5,
      wrap = 85;
      label_val = "After 2010, map drawers redrew CD-27 but kept Farenthold's home county of Nueces.";
    }

    centroids.push({
      class: 'farenthold',
      data: centroid_nueces,
      label: label_val,
      x: x_val,
      y: y_val,
      dy: dy_val,
      dx: dx_val,
      wrap: wrap
    });
  }

  // Note Nueces County on first map
  if (c_year == first_year && wrapper_id != gVars.map_mini  && wrapper_id != gVars.map_farenthold_home) {
    dy_val = 25;
    dx_val = 15;
    wrap = 90;
    label_val = 'Nueces County';

    if (map_class == 'four') {
      if (window.innerWidth > gVars.mobile_width) {
        x_val = centroid_nueces[0][0] + 18;
      } else {
        x_val = centroid_nueces[0][0] + 14;
        dy_val = 30;
        dx_val = 15;
      }
      y_val = centroid_nueces[0][1];
    } else if (wrapper_id == gVars.map_hispanic) {
      if (window.innerWidth > gVars.mobile_width) {
        x_val = centroid_nueces[0][0] + 25;
        y_val = centroid_nueces[0][1] + 3;
        dy_val = -12;
        dx_val = 50;
      } else {
        x_val = centroid_nueces[0][0] + 14;
        y_val = centroid_nueces[0][1];
        dy_val = -12;
        dx_val = 25;
      }
    } else if (all_texas) {
      y_val = centroid_nueces[0][1] + 1;

      if (window.innerWidth > gVars.mobile_width) {
        x_val = centroid_nueces[0][0] + 11;
        dy_val = 15;
        wrap = 60;
      } else {
        x_val = centroid_nueces[0][0] + 5;
        dy_val = 5;
        wrap = 60;
      }
    } else {
      y_val = centroid_nueces[0][1] + 3,
      wrap;

      if (map_class == 'three' || map_class == 'two') {
        wrap = 130;
        y_val = centroid_nueces[0][1] + 1;

        if (window.innerWidth > gVars.mobile_width) {
          x_val = centroid_nueces[0][0] + 22;
        } else {
          y_val = centroid_nueces[0][1] + 2;
          x_val = centroid_nueces[0][0] + 13;
          dx_val = 10;
          dy_val = 20;
          wrap = 50;
        }
      }

      if (map_class == 'three') {
        wrap = 90;
      }

      if (c_year == 2008 && wrapper_id == gVars.map_vtds) {
        label_val = "In 2008, CD-27 was as solidly Democratic as it had been since 1982.";
        y_val = centroid_nueces[0][0] + 50;
        x_val = centroid_nueces[0][0] + 13;
        dx_val = 20;
        dy_val = 15;
        wrap = 100;

        if (window.innerWidth > gVars.mobile_width) {
          y_val = centroid_nueces[0][0] + 50;
          x_val = centroid_nueces[0][0] + 13;
          dx_val = 20;
          dy_val = 15;
          wrap = 100;
        } else {
          y_val = centroid_nueces[0][0] + 15;
          x_val = centroid_nueces[0][0] + 8;
          dx_val = 20;
          dy_val = 15;
          wrap = 80;
        }
      } else if (wrapper_id == gVars.map_hod_zoom) {
        if (window.innerWidth > gVars.mobile_width) {
          x_val = centroid_nueces[0][0] + 20;
          wrap = 40;
        } else {
          x_val = centroid_nueces[0][0] + 10;
          dx_val = 10;
          dy_val = 20;
          wrap = 60;
        }
      } else {
        x_val = centroid_nueces[0][0] + 24;
      }
    }

    if (wrapper_id != gVars.map_hispanic) {
      centroids.push({
        class: 'nueces',
        data: centroid_nueces,
        label: label_val,
        x: x_val,
        y: y_val,
        dy: dy_val,
        dx: dx_val,
        wrap: wrap
      });
    }
  } else if (c_year == 1992 && wrapper_id == gVars.map_mini) {
    centroids.push({
      class: 'map-mini',
      data: centroid_nueces,
      label: '10-year redistricting changes shapes of many districts, including CD-27',
      x: centroid_nueces[0][0],
      y: centroid_nueces[0][1] - 10,
      dy: 1,
      dx: 20
    });
  } else if (c_year == 2004 && wrapper_id == gVars.map_mini) {
    centroids.push({
      class: 'map-mini',
      data: centroid_nueces,
      label: 'Court rules CD-27 needs to be redrawn after lawsuits following redistricting',
      x: centroid_nueces[0][0],
      y: centroid_nueces[0][1] - 10,
      dy: 1,
      dx: 20
    });
  } else if (c_year == 2002 && wrapper_id == gVars.map_mini) {
    centroids.push({
      class: 'map-mini',
      data: centroid_nueces,
      label: 'A small sliver of west Nueces County is placed outside CD-27',
      x: centroid_nueces[0][0],
      y: centroid_nueces[0][1] - 6,
      dy: 0,
      dx: 20
    });
  } else if (c_year == 2010 && wrapper_id == gVars.map_mini || c_year == 2010 && wrapper_id == gVars.map_vtds) {
    if (wrapper_id == gVars.map_mini) {
      wrap = 60;
      x_val = centroid_27[0][0] + 6;
      y_val = centroid_27[0][1] - 30;
    } else {
      if (window.innerWidth > gVars.mobile_width) {
        x_val = centroid_27[0][0] + 20;
        y_val = centroid_27[0][1] - 50;
        wrap = 110;
      } else {
        x_val = centroid_27[0][0] + 10;
        y_val = centroid_27[0][1] - 40;
        wrap = 90;
      }
    }
    centroids.push({
      class: 'map-mini',
      data: centroid_27,
      label: "But a statewide GOP wave helped Farenthold squeak out a win against Ortiz in 2010.",
      x: x_val,
      y: y_val,
      dy: 0,
      dx: 15,
      wrap: wrap
    });
  } else if (c_year == 2012 && wrapper_id == gVars.map_mini|| c_year == 2012 && wrapper_id == gVars.map_vtds || c_year == 2012 && wrapper_id == gVars.map_farenthold_home || c_year == 2014 && wrapper_id == gVars.map_farenthold_home) {
    wrap = 60;
    if (wrapper_id == gVars.map_mini) {
      label_val = 'The new shape of CD-27';
      x_val = centroid_27[0][0] + 10;
      y_val = centroid_27[0][1] + 20;
    } else {
      if (window.innerWidth > gVars.mobile_width) {
        x_val = centroid_27[0][0] + 5;
        y_val = centroid_27[0][1] + 20;
        wrap = 120;
      } else {
        x_val = centroid_27[0][0] - 5;
        y_val = centroid_27[0][1] + 5;
        wrap = 80;
      }

      if (wrapper_id == gVars.map_vtds) {
        if (window.innerWidth > gVars.mobile_width) {
          label_val = 'Lawmakers in 2011 overhauled the shape of CD-27, and Farenthold won by a larger margin the following year.';
        } else {
          label_val = 'Lawmakers in 2011 changed the shape of CD-27, and Farenthold is re-elected in 2012.';
        }
      } else if (c_year == 2012 && wrapper_id == gVars.map_farenthold_home) {
        if (window.innerWidth > gVars.mobile_width) {
          label_val = "The redrawn CD-27 includes Farenthold's home and more Republican voters in Central Texas.";
        } else {
          label_val = "The redrawn CD-27 includes Farenthold's home and more Republican voters.";
        }
      } else if (c_year == 2014 && wrapper_id == gVars.map_farenthold_home) {
        label_val = "With more GOP voters in CD-27, Farenthold won by an even larger margin in 2014.";
      }
    }
    centroids.push({
      class: 'map-mini',
      data: centroid_27,
      label: label_val,
      x: x_val,
      y: y_val,
      dy: 20,
      dx: 10,
      wrap: wrap
    });
  }

  return centroids;
}

export function setAnnotations(
    c_year, c_year_fp_prop, c_topojson_data, nueces_topojson, svg_elements, geo_path, first_year, all_texas
  ) {
  var wrapper_id = svg_elements[3];

  // The center of District 27
  var centroid_27 = c_topojson_data.features
    .filter(function(feature) {
      if (feature.properties[c_year_fp_prop] == "27") {
        return feature;
      }
    })
    .map(function(feature) {
      return geo_path.centroid(feature);
    });

  // The center of District 35
  var centroid_35 = c_topojson_data.features
    .filter(function(feature) {
      if (feature.properties[c_year_fp_prop] == "35") {
        return feature;
      }
    })
    .map(function(feature) {
      return geo_path.centroid(feature);
    });

  // The center of Nueces County
  var centroid_nueces = nueces_topojson.features
    .map(function(feature) {
      return geo_path.centroid(feature);
    });

  // Each annotation has a centroid
  // The number of centroids will determine
  // the number of annotations
  var centroids = setCentroids(
    c_year, centroid_27, centroid_nueces, svg_elements, first_year, all_texas, centroid_35
  );

  // Add annotation for each centroid
  for (var x = 0; x < centroids.length; x++) {
    var c_centroid = centroids[x],
      wrap = 90;

    // Allow for oversetting the wrap attr if we want
    if (c_centroid.wrap != null && c_centroid.wrap != undefined && c_centroid.wrap != 0) {
      wrap = c_centroid.wrap;
    }

    var annotation = [
      {
        note: {
          label: c_centroid.label,
          wrap: wrap,
        },
        x: c_centroid.x,
        y: c_centroid.y,
        dy: c_centroid.dy,
        dx: c_centroid.dx,
        subject: {
          radius: 0.0001
        },
      },
    ];

    const makeAnnotations = d3annotation
      .annotation()
      .type(d3annotation.annotationXYThreshold)
      .annotations(annotation);

    var svg = svg_elements[0];
    svg.select('.annotations-g')
      .append('g')
      .attr('class', 'annotation-' + c_year + ' annotation-' + c_centroid.class)
      .call(makeAnnotations);
  // close for loop
  }
}



// WEBPACK FOOTER //
// ./03-annotations.js